import React from 'react'
import Helmet from 'react-helmet'
import PropTypes from 'prop-types'

const MetaHelmet = ({
  metaTitle,
  metaDescription,
  imageSrc,
  canonicalUrl
}) =>
  <Helmet>
    <meta name="title" content={ metaTitle } />
    <meta name="description" content={ metaDescription } />
    <meta name="robots" content="index, follow" />
    <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
    <meta name="language" content="English" />

    <meta property="og:title" content={ metaTitle } />
    <meta property="og:description" content={ metaDescription } />
    <meta property="og:type" content="website" />
    <meta property="og:image" content={ imageSrc } />
    <meta property="og:url" content={ canonicalUrl } />
    <meta property="og:locale" content="en_US" />
    <meta property="og:site_name" content="Big O Tires" />

    <meta name="twitter:card" content="summary" />
    <meta name="twitter:title" content={ metaTitle } />
    <meta name="twitter:description" content={ metaDescription } />
    <meta name="twitter:url" content={ canonicalUrl } />
    <meta name="twitter:image" content={ imageSrc } />
  </Helmet>

MetaHelmet.propTypes = {
  canonicalUrl: PropTypes.string,
  imageSrc: PropTypes.string,
  metaDescription: PropTypes.string,
  metaTitle: PropTypes.string
}

export default MetaHelmet
